<template>
  <CRow>
    <CCol lg="12">
      <CCard>
        <CCardBody class="pt-0">
          <CDataTable
            :items="actions"
            :fields="filteredFields"
            :tableFilter="{label :'Bộ lọc: ', placeholder:'Nội dung' }"
            :itemsPerPageSelect="{label:' '}"
            pagination
          >
            <template #no-items-view>
              <div style="color: #888; text-align: center; padding: 10px; font-style: italic;">
                Danh sách trống!
              </div>
            </template>

            <template #stt="{item, index}">
              <td class="py-2">
                {{index+1}}
              </td>
            </template>

          </CDataTable>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
export default {
  data() {
    return {
      // Define the table fields
      fields: [
        { key: 'stt', label: 'Stt'},
        { key: 'user', label: 'Tài khoản', role: 'root' },
        { key: 'action', label: 'Thao tác'},
        { key: 'result', label: 'kết quả'},
        { key: 'notified', label: 'Thông báo'},
        { key: 'time', label: 'Thời gian' },
      ],
      // Example data
      actions: [],
      userRole: '',
    };
  },
  mounted() {
    this.userRole = localStorage.getItem('role');
  },
  created() {
    this.getAll()
  },
  computed: {
    filteredFields() {
      return this.fields.filter(field => !field.role || field.role === this.userRole);
    },
  },
  methods: {
    getAll() {
      this.$request.get('/api/actions-all').then(res => {
        // console.log(res.data)
        this.actions = res.data.actions
      })
    },
  }
};
</script>
